var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images.length > 0
    ? _c(
        "div",
        { staticClass: "bulletin-gallery" },
        [
          _vm._l(_vm.images, function(image) {
            return _c(
              "div",
              {
                key: image.id,
                staticClass: "bulletin-gallery-image",
                on: {
                  click: function($event) {
                    return _vm.openPreview(image)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "image",
                  attrs: {
                    src: _vm.getImageViewUrl(image),
                    alt: image.description
                  }
                })
              ]
            )
          }),
          _c(
            "a-modal",
            {
              staticStyle: { "user-select": "none" },
              attrs: {
                visible: _vm.previewVisible,
                footer: null,
                width: "80%"
              },
              on: {
                cancel: function($event) {
                  _vm.previewVisible = false
                },
                ok: function($event) {
                  _vm.previewVisible = false
                }
              }
            },
            [
              _vm.images.length > 1
                ? _c(
                    "div",
                    { staticClass: "navigation" },
                    [
                      _c("a-icon", {
                        attrs: { type: "arrow-left" },
                        on: {
                          click: function($event) {
                            return _vm.previousPreviewImage(_vm.previewImage)
                          }
                        }
                      }),
                      _c("a-icon", {
                        attrs: { type: "arrow-right" },
                        on: {
                          click: function($event) {
                            return _vm.nextPreviewImage(_vm.previewImage)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.previewImage
                ? _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      alt: "Előnézet",
                      src: _vm.getImageViewUrl(_vm.previewImage, 1920)
                    }
                  })
                : _vm._e()
            ]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }